import {DataTransferObjectValidation} from "../../../../type/Types";

export namespace PlacePathJointDataTransferObject {
    export type Post = {
        exposedAt: string
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = {
            exposedAt: '노출일'
        }

        export const validation: DataTransferObjectValidation<Post> = {
            exposedAt(o: string): string | Error {
                return DataTransferObjectValidation.validateDate(o, 'exposedAt')
            }
        }
    }

    export type PatchState = {
        wishState: boolean
    }

    export namespace PatchState {
        export const description: Record<keyof PatchState, string> = {
            wishState: '활성화 여부'
        }

        export const validation: DataTransferObjectValidation<PatchState> = {
            wishState(o: string): boolean | Error {
                return DataTransferObjectValidation.transformBoolean(o, 'wishState')
            }
        }
    }
}